module.exports = "<div id=\"network-diagram\" #networkDiagram></div>\n\n\n"